/**
 * Создает объект с функциями обратного вызова для обработки результатов отправки формы.
 * @returns {object} - Объект с функциями обратного вызова.
 */
function webinarOrderRequest() {
    /**
     * Функция вызывается перед отправкой запроса и добавляет класс 'loader' к элементу body для отображения индикатора загрузки.
     */
    const beforeSend = () => document.body.classList.add('loader');

    const success = (response, form) => {
        // console.log(response);
        // console.log(form);
        form.querySelector('input[name="deal_id"]').remove();
        form.removeAttribute('data-auto-submited');
        cloudPaymentsPay(
            window.location.href,
            response['description'],
            response['order_cost'],
            response['user_email'],
            response['order_id'],
            response['data'],
            response['public_id'],
            response['customer_receipt']
        );
        fadeOut(form.closest('.modal'), 0);
    }

    /**
     * Функция вызывается при возникновении ошибки во время запроса и обрабатывает ошибку.
     * @param {XMLHttpRequest} xhr - Объект XMLHttpRequest, содержащий информацию о запросе.
     * @param {string} exception - Строка, содержащая описание типа ошибки.
     */
    const onError = (xhr, exception) => this.ajaxErrors(xhr, exception);

    /**
     * Функция вызывается после завершения выполнения запроса и удаляет класс 'loader' у элемента body для скрытия индикатора загрузки.
     */
    const onComplete = () => document.body.classList.remove('loader');

    // Возвращаем объект с функциями обратного вызова
    return {beforeSend, success, onError, onComplete};
}

document.addEventListener('DOMContentLoaded', function () {
    const buyWebinar = document.getElementById('buy_webinar');
    const otherWebinarsList = document.querySelector('.webinars-others__slider-wrap');

    if (otherWebinarsList) {
        otherWebinarsSlider(otherWebinarsList);
    }
    if (buyWebinar) {
        buyWebinar.addEventListener('click', () => {
            const cookie = getCookies();
            const modal = document.getElementById('modal_order_webinar');
            const modalPrice = modal.querySelector('.modal__price');
            const webinarPrice = buyWebinar.dataset.price;
            const newPriceHtml = document.createElement('DIV');
            const ageLimit = cookie.age_limit ? parseInt(cookie.age_limit) : 0;
            const modalPromo = modal.querySelector('.input-promocode');
            const args = {
                modal,
                formReset: true
            }

            newPriceHtml.classList.add('price');
            newPriceHtml.textContent = `${webinarPrice} руб`;
            modalPrice.innerHTML = '';
            modalPrice.appendChild(newPriceHtml);

            // console.log(modal.querySelector('.input-promocode'))
            if (modalPromo) {
                modal.querySelector('.promocode__btn_delete').style.display = 'none';
                modal.querySelector('.promocode__btn_apply').style.display = 'block';
                modal.querySelector('.input-promocode').removeAttribute('readonly');
            }

            ageLimit ? ageLimitHandler(args) : initBuyModal(args);
        });
    }

});
